import { render, staticRenderFns } from "./loyalty-campaigns.vue?vue&type=template&id=5da3b45a&scoped=true"
import script from "./loyalty-campaigns.vue?vue&type=script&lang=js"
export * from "./loyalty-campaigns.vue?vue&type=script&lang=js"
import style0 from "./loyalty-campaigns.vue?vue&type=style&index=0&id=5da3b45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da3b45a",
  null
  
)

export default component.exports